<template>
  <div class="py-4 sm:py-6 sm:px-8 max-w-5xl mx-auto">
    <BaseLocaleLink
      v-if="eventRoute && eventsStore.event"
      class="text-primary flex items-center mb-4"
      :to="eventRoute"
    >
      <BaseIcon name="outline_arrow_turn_left" size="xs" class="mr-2" />
      <div>{{ $t('common.back_to') }} {{ eventsStore.event.name }}</div>
    </BaseLocaleLink>
    <PageEditor
      :page-path="route.path"
      :is-admin="authStore.isAdmin"
      :meta-title="$t('tickets.public_offer')"
    />
  </div>
</template>
<script setup lang="ts">
import { useAuth } from '~/stores/auth'
import { useEvents } from '~/stores/events'

const route = useRoute()
const authStore = useAuth()
const eventsStore = useEvents()

const eventSlug = route.params.event as string

onMounted(async () => {
  await eventsStore.fetchEvent(eventSlug)
})

onServerPrefetch(async () => {
  await eventsStore.fetchEvent(eventSlug)
})

const eventRoute = eventsStore.getEventPageRoute(eventSlug)
</script>
